var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ 'message': true, 'success': true, 'active': _vm.active, 'cookie': true }},[_vm._v("\n        "+_vm._s(_vm.$t('message.cookiePolicy'))+"\n        "),_c('a',{staticClass:"message-button",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.accept}},[_vm._v("\n            "+_vm._s(_vm.$t('label.accept'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c03e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CookieWidget.vue
// module id = RHBO
// module chunks = 1